import {PaymentCardsActionTypes} from '../ActionTypes/PaymentCardsActionTypes';

let initialSate = {
  PaymentCardsList: [],
};

const PaymentCardsReducer = (state = initialSate, action) => {
  switch (action.type) {

    case PaymentCardsActionTypes.GET_PAYMENT_CARDS:
      state = {...state, PaymentCardsList: action.payload};
      break;

    case PaymentCardsActionTypes.DELETE_PAYMENT_CARDS_LIST:
      let PaymentCardsList_Copy = [...state.PaymentCardsList];
      PaymentCardsList_Copy.splice(action.payload, 1);
      state = {...state, PaymentCardsList: PaymentCardsList_Copy};
      break;

    case PaymentCardsActionTypes.UPDATE_PAYMENT_CARD:
      let PaymentCardList_Copy = [...state.PaymentCardsList];
      PaymentCardList_Copy.forEach(card => {
        card.default_card = 0;
      });
      PaymentCardList_Copy[action.payload].default_card = 1;
      state = {
        ...state,
        PaymentCardsList: PaymentCardList_Copy,
      };
      break;

      case PaymentCardsActionTypes.UPDATE_PAYMENT_CARD_LIST:
        let UpdatePaymentCardList_Copy = [...state.PaymentCardsList]
        UpdatePaymentCardList_Copy.unshift(action.payload)
        state = {
            ...state,
            PaymentCardsList: UpdatePaymentCardList_Copy
        }
        break;
  }
  return state;
};

export default PaymentCardsReducer;